import * as React from 'react'
import * as _ from 'lodash'
import { Button, Col, Form, ProgressBar, Row } from 'react-bootstrap'
import IosClose from 'react-ionicons/lib/IosClose'
import IosTrash from 'react-ionicons/lib/IosTrash'

import NumberFormatValidate from '../../components/NumberFormatValidate'
import config from '../../constants/config'
import { copyObject, randomId } from '../../utils'


import { bookingStyles as styles } from './BookingUtils'
import InputValidate from './InputValidate'
import { LocationT } from '../../types/Job'
import { OptionsLocationType } from '../jobs/NewJob/OptionsFieldsJob'
import { LocationObj } from '../jobs/NewJob/InitObjectJob'
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete'


interface LocationProps {
    index: number
    location: LocationT
    updateLocation(index: number, location: LocationT)
    removeLocation(index: number): void
}

const Location: React.FunctionComponent<LocationProps> = (props): JSX.Element => {
    const uniqueId = randomId()
    const [location, setLocation] = React.useState(LocationObj)
    const [addressDetails, setAddressDetails] = React.useState(null);
    React.useEffect(() => {

        if (!_.isEqual(props.location, location)) {
            setLocation(props.location)
        }

    }, [props.location]);



    const onChangeValue = (key: string, val: any): void => {
        let locationClone: LocationT = copyObject(location)
        locationClone[key] = val
        setLocation(locationClone)
        props.updateLocation(props.index, locationClone)
    }

    return (
        <div
            style={{
                backgroundColor: '#F5F5F5',
                borderColor: 'lightgray',
                borderWidth: 1,
                borderStyle: 'solid',
                padding: 5,
                marginBottom: 10
            }}>
            <h3>Location {props.index + 1}</h3>
            <Row>
                <Col xs={9}>
                    <Form.Group>
                        <Form.Label>Address <span style={styles.required}>*</span></Form.Label>


                        <GoogleMapAutoComplete
                            customInput={InputValidate}
                            idAddresss={`addressLoction-${uniqueId}`}
                            required
                            // className={` ${addressDetails ? "is-invalid" : "is-valid"}`}
                            apiKey={config.keyMap}

                            onChangeText={text => {

                            }}
                            onPress={async value => {
                                setAddressDetails(value)
                                let locationClone: LocationT = copyObject(location)
                                locationClone.address = value.verbose_address
                                locationClone.addressCountry = value.addressCountry
                                locationClone.addressState = value.addressState
                                locationClone.latitude = value.latitude
                                locationClone.longitude = value.longitude
                                props.updateLocation(props.index, locationClone)
                            }}
                            onValidate={(value) => {
                                return addressDetails ? true : false
                            }}
                            onChangeValue={(value) => {
                                setAddressDetails(null)
                            }}
                            // isValid={addressDetails ? true : false}
                            // isInvalid={!addressDetails}
                            placeholder=''
                            textValue={`${location.address ? location.address : ''}`}
                        />

                        <Form.Control.Feedback type="invalid">
                            You must input a valid address.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={3}>
                    <Form.Group>
                        <Form.Label>Unit #</Form.Label>
                        <Form.Control
                            value={`${location.address2 ? location.address2 : ''}`}
                            onChange={(event: any) => { onChangeValue('address2', event.target.value) }} />
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group>
                <Form.Label>Address Type <span style={styles.required}>*</span></Form.Label>

                <Form.Control
                    as="select"
                    required
                    // type='text'

                    value={`${location.locationType ? location.locationType : ''}`}
                    // onValidate={(value) => {
                    //     return value && value != ""
                    // }}
                    onChange={(e) => {
                        onChangeValue('locationType', e.target.value)
                    }} >
                    <option></option>
                    {Object.keys(OptionsLocationType).map((key, index) => {
                        return (
                            <option key={index} value={key} >{OptionsLocationType[key]}</option>
                        )
                    })}



                </Form.Control>
                <Form.Control.Feedback type="invalid">
                    You must input location type.
                </Form.Control.Feedback>
            </Form.Group>
            <Row>
                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>Num. Rooms <span style={styles.required}>*</span></Form.Label>

                        <NumberFormatValidate
                            onlyNumeric
                            required
                            customInput={Form.Control}
                            // className="input-material"
                            type="text"
                            defaultValue={`${location.numRooms}`}
                            value={`${location.numRooms}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeValue('numRooms', floatValue)
                            }}
                            mask="_" />

                        <Form.Control.Feedback type="invalid">
                            You must input number of rooms.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Form.Label>Flights of Stairs <span style={styles.required}>*</span></Form.Label>
                        <Form.Control as="select"
                            required
                            value={`${location.numStairFlights ? location.numStairFlights : ''}`}
                            onChange={(event: any) => { onChangeValue('numStairFlights', event.target.value) }}>
                            <option></option>
                            <option>0</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4+</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            You must input flights of stairs.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>


            <Button
                onClick={() => {
                    props.removeLocation(props.index)
                }}
                variant="danger">
                <IosTrash
                    color="white"
                    height="20px"
                    width="20px" />
                Remove Location
            </Button>
        </div>
    )
}

export default Location